<div class="tw-mb-1" *ngIf="showRegionSelector">
  <bit-menu #environmentOptions>
    <a
      *ngFor="let region of availableRegions$ | async"
      bitMenuItem
      [attr.href]="
        region == currentRegion ? 'javascript:void(0)' : region.urls.webVault + routeAndParams
      "
    >
      <bit-icon
        name="bwi-check"
        class="bwi-fw bwi-sm"
        [style.visibility]="region == currentRegion ? 'visible' : 'hidden'"
      ></bit-icon>
      {{ region.domain }}
    </a>
  </bit-menu>
  <div bitTypography="body2">
    {{ "accessing" | i18n }}:
    <a [routerLink]="[]" [bitMenuTriggerFor]="environmentOptions">
      <b class="tw-text-primary-600 tw-font-medium">{{ currentRegion?.domain }}</b>
      <bit-icon name="bwi-angle-down" class="bwi-fw bwi-sm"></bit-icon>
    </a>
  </div>
</div>
